import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import SyncIcon from '@material-ui/icons/Sync';

const useStyles = makeStyles((theme) => ({
  enveloppe: {
    padding: theme.spacing(1.5),
    marginBottom: theme.spacing(2),
    border: '1px solid #e5e7eb',
    boxShadow: 'none',
  },
  entete: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    alignItems: 'flex-start',
    flexWrap: 'wrap',
  },
  question: {
    color: '#374151',
    fontWeight: 600,
  },
  intention: {
    color: '#6b7280',
    fontSize: 12,
  },
  icone: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    color: '#6b7280',
    fontSize: 12,
  },
}));

const CockpitSyncStatsRefNavigation = () => {
  const classes = useStyles();

  return (
    <Paper className={classes.enveloppe}>
      <div className={classes.entete}>
        <div>
          <Typography variant="overline">Cockpit SyncStatsRef</Typography>
          <Typography variant="body1" className={classes.question}>
            Les appareils SyncStatsRef fonctionnent-ils correctement ?
          </Typography>
          <Typography variant="body2" className={classes.intention}>
            Visibilite, diagnostic, sante des appareils de synchronisation stats/scores.
          </Typography>
        </div>
        <div className={classes.icone}>
          <SyncIcon fontSize="small" />
        </div>
      </div>
    </Paper>
  );
};

export default CockpitSyncStatsRefNavigation;



// WEBPACK FOOTER //
// src/components/cockpit/CockpitSyncStatsRefNavigation.js